export const traineeAssessmentTooltip = 'Assigned quizzes and exams not yet completed'

export const traineeResultsTooltip =
  'Lessons, lesson quizzes, and course exams you have completed appear here.'
